import { createContext, useContext, useEffect, useState } from "react";
import { CONTACTS } from "@/data/content";

const SettingsContext = createContext(CONTACTS);

export const useSiteSettings = () => useContext(SettingsContext);

export const buildContacts = (s) => {
  const digits = (v) => (v || "").replace(/[^\d+]/g, "");
  const waDigits = (v) => (v || "").replace(/[^\d]/g, "");
  const phone = (s.phone || "").trim() || CONTACTS.phoneDisplay;
  const mobile = (s.mobile || "").trim() || CONTACTS.mobileDisplay;
  const wa = waDigits(s.whatsapp) || "393451234567";
  const email = (s.email || "").trim() || CONTACTS.email;
  const address = (s.address || "").trim() || CONTACTS.address;
  return {
    phoneDisplay: phone,
    phoneHref: `tel:${digits(phone)}`,
    mobileDisplay: mobile,
    mobileHref: `tel:${digits(mobile)}`,
    whatsapp: `https://wa.me/${wa}`,
    email,
    address,
    mapsEmbed: `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`,
  };
};

export const SettingsProvider = ({ children }) => {
  const [contacts, setContacts] = useState(CONTACTS);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`)
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => {
        if (s) setContacts(buildContacts(s));
      })
      .catch(() => {});
  }, []);
  return <SettingsContext.Provider value={contacts}>{children}</SettingsContext.Provider>;
};
